import { NgModule } from '@angular/core';
import { CheckboxModule } from 'primeng/checkbox';
import { CheckboxComponent } from './checkbox.component';
import { CommonModule } from '@angular/common';
import { TypographyComponentModule } from '../typography/typography.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [CheckboxComponent],
  imports: [
    CommonModule,
    CheckboxModule,
    TypographyComponentModule,
    ReactiveFormsModule,
  ],
  exports: [CheckboxModule, CheckboxComponent],
})
export class CheckboxComponentModule {}
